import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import { stringify } from '../../common/util/stringify';
import { MAX_PAYLOAD_SIZE } from '../../common/constants/agent-constants';

var _buffer = /*#__PURE__*/new WeakMap();

var _rawBytes = /*#__PURE__*/new WeakMap();

var _bufferBackup = /*#__PURE__*/new WeakMap();

var _rawBytesBackup = /*#__PURE__*/new WeakMap();

export var EventBuffer = /*#__PURE__*/function () {
  /**
   * @param {number} maxPayloadSize
   */
  function EventBuffer() {
    var maxPayloadSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MAX_PAYLOAD_SIZE;

    _classCallCheck(this, EventBuffer);

    _buffer.set(this, {
      writable: true,
      value: []
    });

    _rawBytes.set(this, {
      writable: true,
      value: 0
    });

    _bufferBackup.set(this, {
      writable: true,
      value: void 0
    });

    _rawBytesBackup.set(this, {
      writable: true,
      value: void 0
    });

    this.maxPayloadSize = maxPayloadSize;
  }

  _createClass(EventBuffer, [{
    key: "isEmpty",
    value: function isEmpty() {
      return _classPrivateFieldGet(this, _buffer).length === 0;
    }
  }, {
    key: "get",
    value: function get() {
      return _classPrivateFieldGet(this, _buffer);
    }
  }, {
    key: "byteSize",
    value: function byteSize() {
      return _classPrivateFieldGet(this, _rawBytes);
    }
  }, {
    key: "wouldExceedMaxSize",
    value: function wouldExceedMaxSize(incomingSize) {
      return _classPrivateFieldGet(this, _rawBytes) + incomingSize > this.maxPayloadSize;
    }
    /**
     * Add feature-processed event to our buffer. If this event would cause our total raw size to exceed the set max payload size, it is dropped.
     * @param {any} event - any primitive type or object
     * @returns {Boolean} true if successfully added; false otherwise
     */

  }, {
    key: "add",
    value: function add(event) {
      var _stringify;

      var addSize = ((_stringify = stringify(event)) === null || _stringify === void 0 ? void 0 : _stringify.length) || 0; // (estimate) # of bytes a directly stringified event it would take to send

      if (_classPrivateFieldGet(this, _rawBytes) + addSize > this.maxPayloadSize) return false;

      _classPrivateFieldGet(this, _buffer).push(event);

      _classPrivateFieldSet(this, _rawBytes, _classPrivateFieldGet(this, _rawBytes) + addSize);

      return true;
    }
    /**
     * Wipes the main buffer
     */

  }, {
    key: "clear",
    value: function clear() {
      _classPrivateFieldSet(this, _buffer, []);

      _classPrivateFieldSet(this, _rawBytes, 0);
    }
    /**
     * Backup the buffered data and clear the main buffer
     * @returns {Array} the events being backed up
     */

  }, {
    key: "save",
    value: function save() {
      _classPrivateFieldSet(this, _bufferBackup, _classPrivateFieldGet(this, _buffer));

      _classPrivateFieldSet(this, _rawBytesBackup, _classPrivateFieldGet(this, _rawBytes));
    }
    /**
     * Wipes the backup buffer
     */

  }, {
    key: "clearSave",
    value: function clearSave() {
      _classPrivateFieldSet(this, _bufferBackup, undefined);

      _classPrivateFieldSet(this, _rawBytesBackup, undefined);
    }
    /**
     * Prepend the backup buffer back into the main buffer
     */

  }, {
    key: "reloadSave",
    value: function reloadSave() {
      if (!_classPrivateFieldGet(this, _bufferBackup)) return;
      if (_classPrivateFieldGet(this, _rawBytesBackup) + _classPrivateFieldGet(this, _rawBytes) > this.maxPayloadSize) return;

      _classPrivateFieldSet(this, _buffer, [].concat(_toConsumableArray(_classPrivateFieldGet(this, _bufferBackup)), _toConsumableArray(_classPrivateFieldGet(this, _buffer))));

      _classPrivateFieldSet(this, _rawBytes, _classPrivateFieldGet(this, _rawBytesBackup) + _classPrivateFieldGet(this, _rawBytes));
    }
  }]);

  return EventBuffer;
}();